// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/field.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome {
  display: flex;
  align-items: center;
  font-family: "Lobster", sans-serif;
  animation: fadeIn 5s 1;
  font-size: 3rem;
  height: 10%;
}

.StartScreen {
  position: absolute;
  display: flex;
  flex-direction: column;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  aspect-ratio: 3/4;
  max-height: 95%;
  min-height: 100vmin;
  min-width: 100vmin;
  max-width: 100vw;
  max-height: 100vh;
  align-items: center;
  justify-content: center;
  color: white;
  align-self: center;
  background-size: cover;
}

.StartScreen-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  animation: fadeIn 5s;
  align-content: center;
  justify-content: center;
}

.intro {
  display: flex;
  flex-direction: row;
  width: 80%;
  font-size: 2.75vmin;
  text-align: center;
}

.mascot {
  width: 70%;
  pointer-events: none;
  animation: wiggle 2s infinite;
  align-self: center;
}

@keyframes wiggle {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(5deg) scale(1, 1.2);
  }
  50% {
    transform: rotate(0deg) scale(1, 0.8);
  }
  75% {
    transform: rotate(-5deg) scale(1, 1.2);
  }
  100% {
    transform: rotate(0deg);
  }
}
.welcome {
  animation: fadeIn 5s;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1em;
  padding: 1em;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.horse {
  position: relative;
  left: 0;
  bottom: 4;
  opacity: 0;
  height: 4em;
  width: 4em;
}

.run {
  animation: run 20s 1;
}

@keyframes run {
  0% {
    transform: translate(-400%, 0%);
    opacity: 1;
  }
  100% {
    transform: translate(100vw, 0%);
    opacity: 1;
  }
}
.new-game {
  box-shadow: none;
}

.new-game:hover {
  box-shadow: none;
  animation: bounce 2s ease infinite;
}

input {
  padding: 0.5em;
  margin: 0.5em;
  text-align: center;
  border-radius: 25px;
}

@keyframes bounce {
  0%, 30%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-15%);
  }
  60% {
    transform: translateY(-7%);
  }
}
@media screen and (max-width: 768px) {
  .welcome {
    font-size: 6vmin;
  }
  .input {
    font-size: 3vmin;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/StartScreen.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yDAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,oBAAA;EACA,6BAAA;EACA,kBAAA;AACF;;AAEA;EACE;IAAK,uBAAA;EAEL;EADD;IAAM,qCAAA;EAIL;EAHD;IAAM,qCAAA;EAML;EALD;IAAM,sCAAA;EAQL;EAPF;IAAO,uBAAA;EAUL;AACF;AARA;EACE,oBAAA;AAUF;;AAPA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AAUF;;AAPA;EACE;IACE,UAAA;EAUF;EARA;IACE,UAAA;EAUF;AACF;AAPA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AASF;;AANA;EACE,oBAAA;AASF;;AANA;EACE;IACE,+BAAA;IACA,UAAA;EASF;EAPA;IACE,+BAAA;IACA,UAAA;EASF;AACF;AANA;EACE,gBAAA;AAQF;;AALA;EACE,gBAAA;EACA,kCAAA;AAQF;;AALA;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAQF;;AALA;EACE;IACE,wBAAA;EAQF;EANA;IACE,2BAAA;EAQF;EANA;IACE,0BAAA;EAQF;AACF;AALA;EACE;IACE,gBAAA;EAOF;EALA;IACE,gBAAA;EAOF;AACF","sourcesContent":[".welcome {\n  display: flex;\n  align-items: center;\n  font-family: 'Lobster', sans-serif;\n  animation: fadeIn 5s 1;\n  font-size: 3rem;\n  height: 10%;\n}\n\n.StartScreen {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background-image: url(\"../assets/images/field.jpg\");\n  aspect-ratio: 3/4;\n  max-height: 95%;\n  min-height: 100vmin;\n  min-width: 100vmin;\n  max-width: 100vw;\n  max-height: 100vh;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  align-self: center;\n  background-size: cover;\n}\n\n.StartScreen-container{\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  animation: fadeIn 5s;\n  align-content: center;\n  justify-content: center;\n}\n\n.intro {\n  display: flex;\n  flex-direction: row;\n  width: 80%;\n  font-size: 2.75vmin;\n  text-align: center;\n}\n\n.mascot {\n  width: 70%;\n  pointer-events: none;\n  animation: wiggle 2s infinite;\n  align-self: center;\n}\n\n@keyframes wiggle {\n  0% { transform: rotate(0deg); }\n 25% { transform: rotate(5deg) scale(1, 1.2); }\n 50% { transform: rotate(0deg) scale(1, .8);  }\n 75% { transform: rotate(-5deg) scale(1, 1.2); }\n100% { transform: rotate(0deg); }\n}\n\n.welcome {\n  animation: fadeIn 5s;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1em;\n  padding: 1em;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.horse {\n  position: relative;\n  left: 0;\n  bottom: 4;\n  opacity: 0;\n  height: 4em;\n  width: 4em;\n}\n\n.run{\n  animation: run 20s 1;\n}\n\n@keyframes run {\n  0% {\n    transform: translate(-400%, 0%);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(100vw, 0%);\n    opacity: 1;\n  }\n}\n\n.new-game {\n  box-shadow: none;\n}\n\n.new-game:hover {\n  box-shadow: none;\n  animation: bounce 2s ease infinite;\n}\n\ninput {\n  padding: .5em;\n  margin: .5em;\n  text-align: center;\n  border-radius: 25px;\n}\n\n@keyframes bounce {\n  0%, 30%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  20% {\n    transform: translateY(-15%);\n  }\n  60% {\n    transform: translateY(-7%);\n  }\n}\n\n@media screen and (max-width: 768px){\n  .welcome {\n    font-size: 6vmin;\n  }\n  .input {\n    font-size: 3vmin;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
